import React from 'react';
import { locations } from '../data/mockData';
import { MapPin, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const Locations = ({ onCitySelect }) => {
  return (
    <section id="locations" className="py-20 bg-neutral-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-4">Nuestras sedes en Ecuador</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {locations.map((location) => (
            <Card key={location.id} className="overflow-hidden border-0 shadow-lg hover:shadow-2xl transition-all duration-500">
              <div className="aspect-video overflow-hidden bg-neutral-200">
                <iframe
                  src={location.mapUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={`Mapa de ${location.city}`}
                ></iframe>
              </div>
              <CardContent className="p-8">
                <h3 className="text-3xl font-serif text-neutral-900 mb-4">{location.city}</h3>
                <div className="flex items-start mb-4">
                  <MapPin className="w-5 h-5 text-neutral-600 mt-1 mr-3 flex-shrink-0" />
                  <p className="text-neutral-600 font-light">{location.address}</p>
                </div>
                <div className="flex items-center mb-6">
                  <MessageCircle className="w-5 h-5 text-neutral-600 mr-3" />
                  <p className="text-neutral-600 font-light">{location.whatsappDisplay}</p>
                </div>
                <Button
                  onClick={() => onCitySelect(location.city)}
                  className="w-full bg-neutral-900 hover:bg-neutral-800 text-white py-6 text-lg rounded-sm transition-all duration-300 hover:shadow-lg"
                >
                  WhatsApp {location.city}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;
